import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const isInitialized = (state: BP42InitialState): boolean => state._initialized;

export default isInitialized;
